import Checkbox from "../Checkbox";
import style from "./style.module.scss";

/**
 * Card de seleção de pacote/avulso: cabeçalho com checkbox + nome + valor total, e o conteúdo
 * (breakdown) sempre visível abaixo — sem accordion. O cabeçalho só fica destacado (fundo
 * primário) quando o item está marcado, não quando está "aberto" (não existe mais esse estado).
 */
export default function PackageSelectionCard(props) {
  const { checked, disabled, name, total, onChange, children } = props;

  return (
    <div className={style.card} data-checked={!!checked}>
      <label className={style.header}>
        {!disabled && <Checkbox className={style.checkbox} checked={!!checked} onChange={onChange} />}
        <span className={style.name}>{name}</span>
        {!!total && <span className={style.total}>{total}</span>}
      </label>
      <div className={style.body}>{children}</div>
    </div>
  );
}
